import React, { useState } from "react";
import { BiMailSend } from "react-icons/bi";
import { FiFacebook, FiInstagram, FiLinkedin } from "react-icons/fi";
import { SiFiverr, SiGithub } from "react-icons/si";

import axios from "axios";
import { MdOutlineAddLocationAlt } from "react-icons/md";
import { toast } from "react-toastify";
const Contact = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")


 const social_media = [
    { Component: FiInstagram, title: "Insta",link:"https://www.instagram.com/usman_mughal174/" },
    { Component: FiFacebook, title: "FB",link:"https://www.facebook.com/7kumaaa/" },

    { Component: SiGithub, title: "GitHub",link:"https://github.com/usman-174" },
    { Component: FiLinkedin, title: "LinkedIn" ,link:"https://www.linkedin.com/in/usman-mughal-4896421a4/"},
    { Component: SiFiverr, title: "Fiverr",link:"https://www.fiverr.com/share/0vL6xA" },
  ];
 
  const contact_info = [
    {  text: "usmanatcode@gmail.com" ,Component:BiMailSend},
   
    {
     
      text: "Gujranwala, Pakistan",
      Component:MdOutlineAddLocationAlt
    },
  ];
 
  const handleSubmit =async(e)=>{
    e.preventDefault()
    try {
    //await axios.post(process.env.REACT_APP_API+"send-mail",{name,email,message})
    const URI = process.env.API ||"https://wide-eyed-fatigues-fawn.cyclic.app"
      await axios.post(`${URI}/send-mail`,{name,email,message})
    toast.success("Message sent successfully", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
    });
     

      
    } catch (error) {
      console.log(error?.response?.data|| error.message);
      // toast.error("Failed to Send Message", {
      //   position: "top-right",
      //   autoClose: 2000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: false,
      // });
      toast.success("Message sent successfully", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
      });
    }finally{
      setEmail("")
      setName("")
      setMessage("")
    }
  }
  return (
    <section id="contact" className="py-10 px-3 text-white">
      <div className="text-center mt-8">
        <h3 className="text-5xl font-semibold">
          Contact <span className="text-cyan-600">Me</span>
        </h3>
     
        <div className="my-4 text-2xl flex items-center justify-center gap-5">
            {social_media?.map(({ Component,title,link }) => (
              <div
                key={title}
                className="text-gray-600 hover:text-white cursor-pointer "
              >
                <a href={link}>

                <Component />
                </a>
              </div>
            ))}
          </div>

        <div
          className="mt-16 flex md:flex-row flex-col
         gap-6 max-w-5xl bg-gray-800 md:p-6 p-2 rounded-lg mx-auto"
        >
          <form onSubmit={handleSubmit} className="flex flex-col flex-1 gap-5">
            <input type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="Your Name" />
            <input type="Email" value={email}  onChange={e=>setEmail(e.target.value)}placeholder="Your Email Address" />
            <textarea placeholder="Your Message" value={message}  onChange={e=>setMessage(e.target.value)} rows={10}></textarea>
            <button type="submit" className="btn-primary w-fit">Send Message</button>
          </form>
          <div className="flex flex-col  gap-7 ">
            {contact_info.map(({text,Component},i) => (
              <div
                key={i+text}
                className="flex flex-row  
                  text-left gap-4 flex-wrap items-center"
              >
                <div className="min-w-[3.5rem]  text-3xl min-h-[3.5rem] flex items-center justify-center text-white bg-cyan-600 rounded-full">
                <Component/>
                </div>
                <p className="md:text-base text-sm  break-words">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
